<template>
  <md-card
    class="md-card-tabs"
    :class="[
      {'flex-column': flexColumn},
      {'nav-pills-icons': navPillsIcons},
      {'md-card-plain': plain}
    ]"
  >
    <md-card-header class="md-card-header-icon">
      <slot name="header">
        <div class="card-icon">
          <md-icon>shopping_cart</md-icon>
        </div>
        <h4 class="title">Cart</h4>
      </slot>
    </md-card-header>
    <md-card-content>
      <md-list class="nav-tabs line">
        <md-list-item
          v-for="(collection, index) in collections"
          @click="switchPanelIndex(index)"
          :key="index"
          :class="[
            {active: isActivePanel(index)},
            {[getColorButtonClass(colorButton)]: isActivePanel(index)}]"
        >
          {{ getTabDisplayName(collection) }}
          <md-icon v-if="navPillsIcons">{{ tabIcon[index] }}</md-icon>
        </md-list-item>
      </md-list>

      <transition name="fade" mode="out-in">
        <div class="tab-content">
          <div class="tab-pane-1">

            <slot name="tab-panel-content">This is the default text!</slot>

          </div>
        </div>
      </transition>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabIcon: Array,
    colorButton: {
      type: String,
      default: ""
    },
    collections: Array,
    initialCollectionIndex: Number
  },
  data() {
    return {
      activePanelIndex: this.initialCollectionIndex
    };
  },
  methods: {
    getTabDisplayName(collection) {
      let selectedItemsCount = this.$store.getters.selectedItemsForCollection(collection.type).length;
      return collection.displayNamePlural + "(" + selectedItemsCount + ")";
    },
    switchPanelIndex(panelIndex) {
      this.activePanelIndex = panelIndex;
      this.$emit("activeCollectionHasChanged", this.collections[panelIndex]);
    },
    isActivePanel(panelIndex) {
      return this.activePanelIndex === panelIndex;
    },
    getColorButtonClass: function (colorButton) {
      return "md-" + colorButton + "";
    }
  }
};
</script>
